import {
  CLEAN_ON_UNMOUNT_TRUE,
  CLEAN_ON_UNMOUNT_FALSE,
  DUPE_LIST_GET,
  DUPE_LIST_CLEAN,
} from '../actionTypes';

const initialState = {
  cleanOnUnmount: true,
  payload: {},
};

const dupeList = (state = initialState, action = {}) => {
  switch (action.type) {
    case DUPE_LIST_GET:
      return {
        ...state,
        payload: action.payload,
      };
    case DUPE_LIST_CLEAN:
      return initialState;
    case CLEAN_ON_UNMOUNT_TRUE:
      return {
        ...state,
        cleanOnUnmount: true,
      };
    case CLEAN_ON_UNMOUNT_FALSE:
      return {
        ...state,
        cleanOnUnmount: false,
      };
    default:
      return state;
  }
};

export default dupeList;
